"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationUploadedItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseTerminationUploadedItemConverter, _DataObjectConverter_);

  function SiteReleaseTerminationUploadedItemConverter() {
    _classCallCheck(this, SiteReleaseTerminationUploadedItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationUploadedItemConverter).apply(this, arguments));
  }

  return SiteReleaseTerminationUploadedItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseTerminationUploadedItemConverter = SiteReleaseTerminationUploadedItemConverter;